import { mapGetters } from "vuex"

export default {
  data() {
    return {
      adresse: "",
      ville: "",
      province: "",
      codePostal: "",
      telephone: "",
      telephoneAuTravail: "",
    }
  },
  methods: {
    fillAdresseFromStore() {
      this.adresse = this.account.adresse.adresse
      this.ville = this.account.adresse.ville
      this.province = this.account.adresse.province.id
      this.codePostal = this.account.adresse.codePostal
      this.telephone = this.account.adresse.telephone
    },
    emptyAdresseValues() {
      this.adresse = ""
      this.ville = ""
      this.province = ""
      this.codePostal = ""
      this.telephone = ""
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.fillAdresseFromStore()
    }
  },
  computed: {
    ...mapGetters(["account", "loggedIn"])
  },
  watch: {
    loggedIn(newVal) {
      if (newVal) {
        this.fillAdresseFromStore()
      } else {
        this.emptyAdresseValues()
      }
    }
  }

}